var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-link"},[_c('div',{staticClass:"image-container",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"image",staticStyle:{"height":"3.5rem","width":"12.25rem"},attrs:{"src":require("@/assets/Rad_205.png"),"alt":"Example Image"}}),_c('div',{staticClass:"text-overlay"},[_vm._v(_vm._s(_vm.txt))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }